// extracted by mini-css-extract-plugin
module.exports = {"chip":"FG9Qae02","upper":"rDgkZpLM","active":"qrDo6hcQ","disabled":"ljqD0f7z","icon":"xerxvCIm"};